export default __webpack_public_path__ + "static/media/Thief's Belt of the Fifth Stage.f6160897.jpg";